<template>
  <a
    :href="url"
    class="flex h-[41px] cursor-pointer select-none items-center border-[--v3-theme-primarydarkercolor]
    bg-[--v3-theme-primarydarkcolor] px-[15px] text-[14px] text-[--v3-theme-primarytextcolor]
    transition-all duration-150 hover:bg-[--v3-theme-primarydarkercolor] active:bg-[--v3-theme-primarydarkercolor]"
  >
    <span class="shop-name">{{ name }}</span>
  </a>
</template>

<script setup lang='ts'>
defineProps<{
  name: string,
  url: string,
}>();
</script>

<style scoped>
.shop-name {
  font-family: Inter, sans-serif;
}
</style>
